import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import cx from 'classnames';

import Button from 'shared_components/Button';

import styles from './styles.module.scss';

type Props = {
  className?: string;
};

const BuyPackButton = (props: Props) => {
  const { isAuth } = useAuth();
  const { className } = props;
  const history = useHistory();
  const handleClick = useCallback(() => {
    history.push({
      pathname: history.location.pathname,
      search: '?modal=pack',
    });
  }, [history]);

  const handleLogin = useCallback(() => {
    history.push({
      pathname: history.location.pathname,
      search: '?modal=login',
    });
  }, [history]);

  return isAuth ? (
    <Button
      size="lg"
      rounded="full"
      onClick={handleClick}
      className={cx(styles.buyPackButton, className)}
    >
      CONNECT WALLET
    </Button>
  ) : (
    <Button
      size="lg"
      rounded="full"
      onClick={handleLogin}
      className={cx(styles.buyPackButton, className)}
    >
      CONNECT WALLET
    </Button>
  );
};

export default BuyPackButton;
